/**
 * Ana sayfa fotoğraflı yorumlar: öncelikli ürünler önde, kartlar ürünler arası karışık.
 */
function groupCardsByHandle(track) {
  const groups = new Map();
  for (const card of track.querySelectorAll('.conv-home-photo-reviews__card')) {
    const handle = card.dataset.productHandle;
    if (!handle) continue;
    if (!groups.has(handle)) groups.set(handle, []);
    groups.get(handle).push(card);
  }
  return groups;
}

async function fetchBestSellingHandles(collectionHandle, limit) {
  try {
    const res = await fetch(
      `/collections/${collectionHandle}/products.json?limit=${limit}&sort_by=best-selling`
    );
    if (!res.ok) return [];
    const data = await res.json();
    return (data.products || []).map((product) => product.handle);
  } catch {
    return [];
  }
}

function interleaveByProduct(handleOrder, groups) {
  const queues = handleOrder
    .filter((handle) => groups.has(handle))
    .map((handle) => [...groups.get(handle)]);

  const ordered = [];
  let hasMore = true;

  while (hasMore) {
    hasMore = false;
    for (const queue of queues) {
      if (!queue.length) continue;
      ordered.push(queue.shift());
      hasMore = true;
    }
  }

  return ordered;
}

async function reorderPhotoReviewCards(section) {
  const track = section.querySelector('[data-trendyol-track]');
  if (!track) return;

  const priority = (section.dataset.priorityHandles || '')
    .split(',')
    .map((handle) => handle.trim())
    .filter(Boolean);
  const collectionHandle = section.dataset.collectionHandle;
  const maxProducts = Number(section.dataset.maxProducts) || 48;
  const groups = groupCardsByHandle(track);

  const handleOrder = [];
  const used = new Set();

  for (const handle of priority) {
    if (!groups.get(handle)?.length) continue;
    handleOrder.push(handle);
    used.add(handle);
  }

  if (collectionHandle) {
    const bestSelling = await fetchBestSellingHandles(collectionHandle, maxProducts);
    for (const handle of bestSelling) {
      if (used.has(handle)) continue;
      if (!groups.get(handle)?.length) continue;
      handleOrder.push(handle);
      used.add(handle);
    }
  }

  for (const handle of groups.keys()) {
    if (!used.has(handle)) handleOrder.push(handle);
  }

  const ordered = interleaveByProduct(handleOrder, groups);
  ordered.forEach((card) => track.appendChild(card));
}

function hydrateReviewPhotos(section) {
  section.querySelectorAll('[data-deferred-review]').forEach((template) => {
    if (template.dataset.ready === 'true') return;
    template.dataset.ready = 'true';
    template.parentElement?.append(template.content.cloneNode(true));
  });
}

function initPhotoReviewSections() {
  document
    .querySelectorAll('.conv-home-photo-reviews[data-collection-handle]')
    .forEach((section) => {
      reorderPhotoReviewCards(section).then(() => {
        if (!('IntersectionObserver' in window)) {
          hydrateReviewPhotos(section);
          return;
        }
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            hydrateReviewPhotos(section);
          },
          { rootMargin: '400px 0px' }
        );
        observer.observe(section);
      });
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPhotoReviewSections);
} else {
  initPhotoReviewSections();
}
